import { DeepPartial } from '../../../types';
import { RoadSection, RoadSectionId } from '../../domain/Reference';
import { createCommand } from '../../utils';
import { moduleName, updatedRoadSection } from '../state';

interface EditRoadSectionParams {
    roadSectionId: RoadSectionId;
    roadSectionData: DeepPartial<RoadSection>;
}

const editRoadSection = createCommand(
    `${moduleName}/EDIT_ROAD_SECTION`,
    async ({ roadSectionData, roadSectionId }: EditRoadSectionParams, { dispatch, extra }) => {
        const [roadSection] = await extra.externalReference.editRoadSections([roadSectionId], roadSectionData);

        dispatch(updatedRoadSection(roadSection as RoadSection));
    },
);

export default editRoadSection;
